import { throwApiError } from 'src/packages/errors';

import type { TDictionarySettings, TDictionarySettingsPatchRequest } from './types';
import type { AxiosInstance } from 'axios';

export class UnitsSettingsApi {
  constructor(private readonly agent: AxiosInstance) {}

  async loadSettings(objectType: string, signal?: AbortSignal): Promise<TDictionarySettings> {
    try {
      const { data } = await this.agent.get<TDictionarySettings>(
        `dictionarySettings/${encodeURIComponent(objectType)}`,
        { signal },
      );

      return data;
    } catch (error) {
      throwApiError(error);
    }
  }

  async patchSettings(
    objectType: string,
    request: TDictionarySettingsPatchRequest,
    signal?: AbortSignal,
  ): Promise<TDictionarySettings> {
    try {
      const { data } = await this.agent.patch<TDictionarySettings>(
        `dictionarySettings/${encodeURIComponent(objectType)}`,
        request,
        { signal },
      );

      return data;
    } catch (error) {
      throwApiError(error);
    }
  }
}
